import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable, shareReplay } from 'rxjs';
import { TournamentsResponse } from '../../all-tournaments/models/api/responses/tournaments.response';
import { CreateTournamentRequest } from '../../tournament/models/api/requests/tournamentGeneral.request';
import {
    PlayerTournamentsType,
    TournamentState,
} from '../../tournament/models/enums/tournaments.enum';
import { Tournament } from '../../tournament/models/tournaments.interface';
import { endpoints } from '../../utils/endpoints';
import { FetchPlayerTournamentsRequest } from '../models/api/requests/profilePlayerTournaments.request';

@Injectable(
    {
        providedIn: 'root',
    }
)
export class ProfilePlayerTournamentsService {
    private http = inject(HttpClient);


    createTournamentDraft(
        request: CreateTournamentRequest
    ): Observable<Tournament> {
        return this.http.post<Tournament>(
            endpoints.tournaments.endpoint,
            request
        );
    }
    createTournamentV2Draft(
        request: CreateTournamentRequest
    ): Observable<Tournament> {
        return this.http.post<Tournament>(
            endpoints.tournaments.children.createV2Tournament(),
            request
        );
    }

    createCustomTournamentDraft(
        request: CreateTournamentRequest
    ): Observable<Tournament> {
        return this.http.post<Tournament>(
            endpoints.tournaments.children.createCustom(),
            request
        );
    }

    updateTournamentDraft(data: Tournament): Observable<Tournament> {
        return this.http.put<Tournament>(endpoints.tournaments.endpoint, data);
    }
    updateTournamentV2Draft(data: Tournament): Observable<Tournament> {
        return this.http.put<Tournament>(endpoints.tournaments.children.createV2Tournament(), data);
    }

    fetchPlayerTournaments(request: FetchPlayerTournamentsRequest) {
        let query = new HttpParams();
        let filters = '';
        const isParticipatingOnly =
            request.type === PlayerTournamentsType.Participating;

        if (isParticipatingOnly) {
            query = query.append('participatingOnly', isParticipatingOnly);
        }

        switch (request.type) {
            case PlayerTournamentsType.Participating:
                filters += `State==${[
                    TournamentState.Published,
                    TournamentState.RegistrationStarted,
                    TournamentState.RegistrationCompleted,
                    TournamentState.SeedingCompleted,
                    TournamentState.Started,
                ].join('|')}`;
                break;
            case PlayerTournamentsType.HostingPublished:
                filters += `CreatedBy==${request.userId}, State==${[
                    TournamentState.Published,
                    TournamentState.RegistrationStarted,
                    TournamentState.RegistrationCompleted,
                    TournamentState.SeedingCompleted,
                    TournamentState.Started,
                ].join('|')}`;
                break;
            case PlayerTournamentsType.HostingDrafted:
                filters += `CreatedBy==${request.userId}, State==${TournamentState.Draft}`;
                break;
            case PlayerTournamentsType.HostingCompleted:
                filters += `State==${TournamentState.Completed}`;
                break;
        }

        query = query.append('Filters', filters);
        query = query.append('PlayerProfileId', request.playerId);
        query = query.append('Page', request.page);

        return this.http
            .get<TournamentsResponse>(
                endpoints.tournaments.children.getPlayerTournaments(
                    request.playerId
                ),
                {
                    params: query,
                }
            )
            .pipe(shareReplay());
    }
}
